export type LogType = 'debug'|'info'|'warning'|'error'|'critical'|'access'|'error_specific';
export const logTypes: LogType[] = ['debug', 'info', 'warning', 'error', 'critical', 'access', 'error_specific'];

export type LogResp = { level: LogType, log: string[], errorCode?: number };
